import { Component } from '@angular/core';
import { BaseResourceDirective } from 'src/app/directives/base-resource.directive';


import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { GlobalDataService } from 'src/app/services/data/global-data.service';
import { ActivatedRoute } from '@angular/router';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-aws-html',
  templateUrl: './aws-html.component.html',
  styleUrls: ['./aws-html.component.sass']
})
export class AwsHtmlComponent extends BaseResourceDirective {

  sanitizedResource: SafeResourceUrl | null = null;

  constructor(
    utils: UtilsService,
    data: GlobalDataService,
    route: ActivatedRoute,
    dialog: DialogService,
    dialogConfig: DynamicDialogConfig,
    dialogRef: DynamicDialogRef,
    http: HttpClient,
    private sanitizer: DomSanitizer) {
    super(
      utils,
      data,
      route,
      dialog,
      dialogConfig,
      dialogRef,
      http
    )
  }

  override onLoadResourceSuccess(result: any) {
    this.available = true
    this.resource = result


    this.sanitizedResource = this.sanitizer.bypassSecurityTrustResourceUrl(result)
    this.loadResourceContent(result)
  }

}
